<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')" modal_style="modal-small">
      <!-- MODAL BODY -->
      <div slot="modal-body">
        <div class="exam-modal-body">
          <!-- PUBLISH ICON -->
          <div class="publish-icon">
            <img v-lazy="localImg('ThumbsUp.png')" alt="" />
          </div>

          <div class="publish-title brand_navy font-weight-700">
            Exam Published
          </div>

          <div class="publish-text">
            You just published
            <span class="font-weight-700">First term examination 1</span> for
            <span class="font-weight-700">SS2-Gold</span> new time and date as
            been updated on your school calendar.
          </div>

          <div class="approve-btn pointer">APPROVE MORE EXAMS</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
// import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";

export default {
  name: "ExamRejectModal",

  components: {
    Modal,
  },

  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.form-title {
  font-size: 16px;
}

.exam-modal-body {
  @include flex_column_center;
  justify-content: flex-start;

  .publish-icon {
    @include custom_min_edge(180, 186);
    position: relative;
    margin-top: -50px;

    img {
      @include img_contain;
    }
  }

  .publish-title {
    margin-top: 5px;
    margin-bottom: 15px;
    font-size: 18.5px;
    line-height: 21px;
    text-align: center;
  }

  .publish-text {
    text-align: center;
    color: $color_text;
    font-size: 14px;
    line-height: 165%;
    margin-bottom: 30px;
    padding: 0 50px;
  }

  .approve-btn {
    width: max-content;
    padding: 12px 40px;
    font-size: 12px;
    font-weight: 700;
    line-height: 163.98%;
    border-radius: 30px;
    background: $brand_accent_light;
    border: 1px solid $brand_accent;
    transition: all 0.4s ease-in-out;

    &:hover {
      background: $brand_inverse_light;
      border: 1px solid $brand_inverse;
    }
  }
}
</style>
